import { Component, Inject } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MappedResponse } from '../../../share/components/ge-select-pagination/ge-select-pagination.component';
import {
  CategoriaEnvaseControllerService,
  CategoriaEnvaseDTO,
  DiccionarioControllerService,
  DiccionarioElementoDTO,
  PageDTOTarifaAdheridoSDDRAbiertoDTO,
  TarifaAdheridoSDDRAbiertoDTO,
  TarifaAdheridoSDDRAbiertoFilterDTO,
  TarifaAdheridoSddrAbiertoControllerService,
  TarifaAdheridoSddrAbiertoSinGobernanzaControllerService,
  TarifaAdheridoUnUsoFilterDTO,
  TipoEnvasesDTO,
  SistemaEnvaseControllerService,
  SistemaEnvaseDTO,
  TarifaAdheridoSDDRAbiertoSinGobernanzaFilterDTO,
} from 'api-rest';
import { RatePackagingSystemDialogComponent } from '../rate-packaging-system-dialog/rate-packaging-system-dialog.component';
import Swal from 'sweetalert2';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { RateCategoryTypeEnum } from '../../models/rate-category-type.enum';
import { FormatCurrencyPipe } from '../../../share/components/pipe/FormatCurrency.pipe';
import { map } from 'rxjs';
import { AttachedRatePackagingSystemMassiveLoadComponent } from '../attached-rate-packaging-system-massive-load/attached-rate-packaging-system-massive-load.component';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';

@Component({
  selector: 'lib-attached-rate-packaging-system-search',
  templateUrl: './attached-rate-packaging-system-search.component.html',
  styleUrls: ['./attached-rate-packaging-system-search.component.scss'],
})
export class AttachedRatePackagingSystemSearchComponent {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;
  tarifaAbierta: TarifaAdheridoSDDRAbiertoDTO[] = [];
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalSearch: number = 0;
  updateList: boolean = false;
  defaultFilter: boolean = true;
  mostrarFiltros: boolean = true;
  headArray: any = [
    {
      Head: 'Año',
      FieldName: 'anio',
    },
    {
      Head: 'Categoría',
      FieldName: 'categoria',
      Attribute: 'descripcion',
      Tooltip: true,
      Maxtext: 30,
    },
    {
      Head: 'Tipo envase',
      FieldName: 'tipoEnvases',
      Attribute: 'descripcion',
      Tooltip: true,
      Maxtext: 30,
    },
    {
      Head: 'Tipología',
      FieldName: 'tipologia',
    },
    {
      Head: 'Peligrosidad',
      FieldName: 'peligrosidad',
      renderValue: (item: TarifaAdheridoSDDRAbiertoDTO) =>
        item.peligrosidad ? 'SI' : 'NO',
    },
    {
      Head: 'CUOTA RAP (€/UD)',
      FieldName: 'eurosUnidad',
      renderValue: (item: any) =>
        this.formatCurrencyPipe.transform(item.eurosUnidad),
    },
    {
      Head: 'Sistema envase',
      FieldName: 'sistemaEnvase.descripcion',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        { nameButton: 'view', icon: 'open_in_new', toolTip: 'Editar' },
        { nameButton: 'delete', icon: 'delete', toolTip: 'Borrar' },
      ],
      width: '10',
    },
  ];
  gridArray: TarifaAdheridoSDDRAbiertoDTO[] = [];

  searchForm: FormGroup;
  categorias: CategoriaEnvaseDTO[] = [];
  sistemasEnvase: SistemaEnvaseDTO[] = [];
  tipoEnvasesEndpoint =
    this.environment.urlBackCore + 'api/v1/core/tipoEnvases';
  orden: DiccionarioElementoDTO[] = [];
  constructor(
    private ratesOpenService: TarifaAdheridoSddrAbiertoSinGobernanzaControllerService,
    private categoriaEnvaseControllerService: CategoriaEnvaseControllerService,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private downloadService: DownloadService,
    private categoryEnvaseService: CategoriaEnvaseControllerService,
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private diccionarioControllerService: DiccionarioControllerService,
    private sistemaEnvaseService: SistemaEnvaseControllerService,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService
  ) {
    this.searchForm = this.formBuilder.group({
      anio: [{ value: null, disabled: false }, [this.customValidator()]],
      categoria: [{ value: null, disabled: false }],
      tipoEnvase: [{ value: null, disabled: false }],
      tipologia: [{ value: null, disabled: false }],
      peligrosidad: [{ value: null, disabled: false }],
      sistemaEnvase: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });
  }

  ngOnInit(): void {
    this.cargarCombos();
    this.comboOrden();
  }

  cargarCombos() {
    this.categoryEnvaseService
      .listarCategoriaEnvases('body')
      .pipe(
        map((res) =>
          res.filter(
            (cat) =>
              cat.id == RateCategoryTypeEnum.IndustrialReutilizableSDDRAbiertoSinGobernanza ||
              cat.id == RateCategoryTypeEnum.ComercialReutilizableSDDRAbiertoSinGobernanza
          )
        )
      )
      .subscribe((res) => (this.categorias = res));

    this.sistemaEnvaseService
      .listarSistemaEnvase('body')
      .subscribe((res) => (this.sistemasEnvase = res));
  }
  comboOrden() {
    this.diccionarioControllerService
      .listarElementos(['ORDEN_ADMIN_TARIFAS_SDDR_ABIERTO_SINGOBERNANZA_BUSQUEDA']) 
      .subscribe((res: { [x: string]: DiccionarioElementoDTO[]; }) => (this.orden = res['ORDEN_ADMIN_TARIFAS_SDDR_ABIERTO_SINGOBERNANZA_BUSQUEDA']));
  }
  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.getRatesOpenService();
    }
  }

  checked(item: any) {}

  searchData() {
    this.pageNumber = 1;
    this.getRatesOpenService();
  }

  customValidator() {
    return (control: { value: any }) => {
      const value = control.value;
      if (!value) {
        return null;
      }
      if (/^\d{4}$/.test(value)) {
        const intValue = parseInt(value, 10);
        if (intValue >= 1900 && intValue <= 2500) {
          return null;
        }
      }
      return { invalid: true };
    };
  }

  getRatesOpenService() {
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      return;
    }
    this.spinnerSrv.loadingShow();
    const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();
    this.ratesOpenService
      .findAll3(backendFilter, {
        page: page,
        size: size,
        sort: ['anio,asc'],
      },
        orden,
        tipoOrden)
      .subscribe({
        next: (data: PageDTOTarifaAdheridoSDDRAbiertoDTO) => {
          if (data) {
            this.flagSearch = data.datos?.length !== 0 ? true : false;
            this.gridArray = data.datos ?? [];
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  private getBackendFilter() {
    const filter = this.searchForm.value;

    if (filter.categoria) {
      filter.categoria = {
        id: filter.categoria.id,
      };
    }

    if (filter.tipoEnvase) {
      filter.tipoEnvase = {
        id: filter.tipoEnvase.id,
      };
    }

    if (filter.enabled == false) {
      delete filter.enabled;
    }

    const backendFilter: TarifaAdheridoSDDRAbiertoSinGobernanzaFilterDTO = {
      anio: filter.anio,
      categoria: filter.categoria,
      tipoEnvases: filter.tipoEnvase,
      tipologia: filter.tipologia as TarifaAdheridoUnUsoFilterDTO.TipologiaEnum,
      peligrosidad: filter.peligrosidad,
      sistemaEnvase: filter.sistemaEnvase
        ? { id: filter.sistemaEnvase }
        : undefined,
    } as TarifaAdheridoSDDRAbiertoSinGobernanzaFilterDTO;

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
        const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }

  action(element: any) {
    if (element.nameButton == 'view') {
      this.openModalRateOpen(element);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    }
  }

  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar la tarifa?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarTarifaOpen(element);
      }
    });
  }

  eliminarTarifaOpen(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.ratesOpenService.deleteById3(element.id).subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `La tarifa se ha eliminado correctamente`,
            'success'
          );
          this.gridArray = this.gridArray.filter(
            (objeto) => objeto.id !== element.id
          );
          this.flagSearch = this.gridArray.length != 0 ? true : false;
        },
        error: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al eliminar la tarifa',
            'error'
          );
        },
      });
    }
  }

  openModalRateOpen(element?: any): void {
    const dialogRef = this.dialog.open(RatePackagingSystemDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        itemOpen: element,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        //this.clearSearcher();
        this.getRatesOpenService();
      }
    });
  }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) => v !== filtro.value);
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }

    this.pageNumber = 1;
    //this.getRatesOpenService();
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const anio = this.searchForm.get('anio')?.value;
    if (anio) filtros.push({ label: `${anio}`, campo: 'anio' });

    const categoria = this.searchForm.get('categoria')?.value;
    if (categoria) {
      filtros.push({
        label: `${categoria?.descripcion ?? String(categoria)}`,
        campo: 'categoria',
      });
    }

    const tipoEnvase = this.searchForm.get('tipoEnvase')?.value;
    if (tipoEnvase) {
      filtros.push({
        label: ` ${tipoEnvase?.descripcion ?? String(tipoEnvase)}`,
        campo: 'tipoEnvase',
      });
    }

    const tipologia = this.searchForm.get('tipologia')?.value;
    if (tipologia) {
      const tipoLabel = tipologia === 'PRIMARIO'
        ? 'Primario'
        : tipologia === 'SECUNDARIO'
          ? 'Secundario'
          : tipologia === 'TERCIARIO'
            ? 'Terciario'
            : String(tipologia);
      filtros.push({ label: ` ${tipoLabel}`, campo: 'tipologia' });
    }

    const peligrosidad = this.searchForm.get('peligrosidad')?.value;
    if (peligrosidad !== null && peligrosidad !== undefined) {
      filtros.push({ label: ` ${peligrosidad ? 'Sí' : 'No'}`, campo: 'peligrosidad' });
    }

const sistemaEnvase = this.searchForm.get('sistemaEnvase')?.value;
    if (sistemaEnvase) filtros.push({ label: `Sistema envase: ${this.sistemasEnvase.find((s) => s.id === sistemaEnvase)?.descripcion ?? sistemaEnvase}`, campo: 'sistemaEnvase' });

    const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }

  exportarExcel() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.ratesOpenService
      .exportTarifaSDDRAbiertoSinGobernanza(backendFilter, 'response')
      .subscribe((res) => {
        this.downloadService.exportModal();
        // const filename = this.downloadService.getFileName(
        //   res.headers,
        //   'Exportacion_Tarifa_SDDR_Abierto.csv'
        // );
        // this.downloadService.downloadCSV(res.body!, filename!);
      });
  }

  mapAdheridosReponse(response: any): MappedResponse<any> {
    return {
      datos: response.content,
      recordsFiltered: response.recordsTotal,
      totalElements: response.totalElements,
    };
  }

  getTipoEnvaseDescription(tipoEnvase: TipoEnvasesDTO) {
    return tipoEnvase.descripcion;
  }

  filterList(selectForm: any) {
    switch (selectForm) {
      case 'tipoEnvase': {
        return this.searchForm.get('tipoEnvase') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'tipoEnvase': {
        return this.searchForm.get('tipoEnvase') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }

  selectedModel(selectForm: any) {
    switch (selectForm) {
      case 'tipoEnvase': {
        break;
      }
      default: {
        break;
      }
    }
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.getRatesOpenService();
  }
    openModalMassiveLoad(): void {
    const dialogRef = this.dialog.open(AttachedRatePackagingSystemMassiveLoadComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getRatesOpenService();
      }
    });
  }

      canViewResource(rol: string): boolean {
        return this.authService.hasCurrentUserRole(rol);
    }
}
